// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__1oErK","errorLogs":"styles_errorLogs__3ZUvU"};